export class OverlayHelper {

  static open(callbackFn = null, withSpinner = false, withOpacity = false): void {
    const overlayClassList = document.getElementById('overlay').classList;
    overlayClassList.add('active');
    if (withSpinner) {
      overlayClassList.add('with-spinner');
    }
    if (withOpacity) {
      overlayClassList.add('opacity-0');
    }

    this.fixBody();
    if (callbackFn) {
      callbackFn();
    }
  }

  static closeEvent(callbackFn = null): void {
    document.addEventListener('overlayClick', () => {
      if (callbackFn) {
        callbackFn();
      }
    }, {once: true});
  }

  static close(callbackFn = null): void {
    const overlay = document.getElementById('overlay');
    overlay.classList.remove('with-spinner');
    overlay.click();
    this.unfixBody();
    if (callbackFn) {
      callbackFn();
    }
  }

  static fixBody(): void {

    if (document.body.clientHeight < document.body.scrollHeight) {
      const diff = window.innerWidth - document.documentElement.clientWidth;
      document.body.classList.add('fixed');
      document.body.style.paddingRight = diff + 'px';
    }

    const counter = document.body.dataset.popupCount?.length ? parseInt(document.body.dataset.popupCount, 10) : 0;
    document.body.dataset.popupCount = String(Math.max(counter + 1, 0));
  }

  static unfixBody(): void {
    const counter = document.body.dataset.popupCount?.length ? parseInt(document.body.dataset.popupCount, 10) : 0;
    document.body.dataset.popupCount = String(Math.max(counter - 1, 0));

    if (counter <= 1) {
      document.body.classList.remove('fixed');
      document.body.style.paddingRight = '';
    }
  }
}
